module.exports = __webpack_public_path__ + "media/Close_1.93870b95.ogg";